module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-300-93.e556e9a.woff2";